import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import ReactPlayer from "react-player";
import * as S from "./nutritionCreation.styles";

// Images
import BackdropImage from "assets/images/backdropWave.svg";
import HandImage from "assets/images/health-analyse/hand-mobile.png";
import LoaderImage from "assets/images/health-analyse/loader.svg";
import Loader from "components/loader/Loader";
// Video
import CreationVideo from "assets/videos/creationVideo.mp4";
import { HEALTHANALYSE_APP } from "routes/routes";

const NutritionCreation = () => {
  const [isMobile, setIsMobile] = useState(false);
  let history = useHistory();

  const handleResize = () => {
    if (window.innerWidth < 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    window.localStorage.removeItem("voucher");
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const redirectToNextPage = () => {
    history.push(HEALTHANALYSE_APP);
    document.body.style.overflowY = "auto";
  };

  // For desktop: light blue background, center text + loader, phone on right
  // For mobile: white background with hand image
  return isMobile ? (
    <S.MobileContainer>
      <S.BackdropImage src={BackdropImage} alt="Backdrop" />

      <S.MobileContent>
        <S.Title>
          Wir richten deine App, deine Lernacademy und dein Coaching ein.
        </S.Title>
        <S.CenteredLoader>
          <Loader />
        </S.CenteredLoader>
      </S.MobileContent>
      <S.MobilePhoneContainer>
        <S.ReactPlayerContainer>
          <ReactPlayer
            url={CreationVideo}
            width="100%"
            height="100%"
            playing={true}
            muted={true}
            playsinline={true}
            onEnded={redirectToNextPage}
            onError={(e) => console.error("Video error:", e)}
            config={{
              file: {
                attributes: {
                  preload: "auto",
                },
              },
            }}
          />
        </S.ReactPlayerContainer>
      </S.MobilePhoneContainer>
    </S.MobileContainer>
  ) : (
    <S.DesktopContainer>
      <S.BackdropImage src={BackdropImage} alt="Backdrop" />
      <S.DesktopContent>
        <S.Title>
          Wir richten deine App, deine Lernacademy und dein Coaching ein.
        </S.Title>
        <S.CenteredLoader>
          <Loader />
        </S.CenteredLoader>
        <S.PhoneContainer>
          <S.ReactPlayerContainer>
            <ReactPlayer
              url={CreationVideo}
              width="100%"
              height="100%"
              playing={true}
              muted={true}
              playsinline={true}
              onEnded={redirectToNextPage}
              onError={(e) => console.error("Video error:", e)}
              config={{
                file: {
                  attributes: {
                    preload: "auto",
                  },
                },
              }}
            />
          </S.ReactPlayerContainer>
        </S.PhoneContainer>
      </S.DesktopContent>
    </S.DesktopContainer>
  );
};

export default NutritionCreation;
